import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

@Component({
    standalone: false,
    selector: 'por-verification-code-help-text',
    templateUrl: './verification-code-help-text.component.html',
    styleUrls: ['./verification-code-help-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerificationCodeHelpTextComponent {
    @Input() email = '';
    @Input() isUserDisabled = false;
    @Input() organizationId = '';
    @Input() storeName?: string;
    @Output() readonly modalClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

    closeModal() {
        this.modalClosed.emit(true);
    }
}
